import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { getCategoryById } from '../config/categories';
import { getSundargarhRulesByCategory } from '../config/sundargarhRules';
import HomeCard from '../shared/HomeCard';
import ComingSoon from '../shared/ComingSoon';

export default function SundargarhCategoryPage() {
  const { id } = useParams();
  const category = getCategoryById(id);

  if (!category) {
    return (
      <div className="page">
        <ComingSoon title="Unknown category" description="This category does not exist." />
      </div>
    );
  }

  const rules = getSundargarhRulesByCategory(category.id);

  return (
    <div className="page">
      <Link to="/sundargarh-hub" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Sundargarh Dashboard
      </Link>
      <div className="page-header">
        <h1 className="page-title">
          <category.icon /> {category.label}
        </h1>
        <p className="page-subtitle">{category.description}</p>
      </div>

      <div className="card-grid">
        {rules.map((rule) => (
          <HomeCard
            key={rule.id}
            to={`/sundargarh-rules/${rule.id}`}
            title={rule.title}
            description={rule.enabled ? rule.description : 'Coming soon — not yet available.'}
            icon={rule.enabled ? CheckCircleIcon : HourglassEmptyIcon}
            accent={rule.enabled ? category.accent : 'var(--muted)'}
            badge={rule.enabled ? 'Available' : 'Coming soon'}
          />
        ))}
      </div>
    </div>
  );
}
